export default  {
    component: 'energy_meter',
    name: 'energy_meter',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'EM ID',
            param: 'em_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, em id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, em id should start from **"1"**`
          },
          {
            name: 'EM Name',
            param: 'em_name',
            type: 'text',
            description: `> For each block device name should be unique`
          },
          {
            name: 'AC Capacity',
            param: 'ac_capacity',
            type: 'number',
            description: `Its a mandatory data for the calculation of **"PR"**. It should be sum of all the inverters capacities present in that specific Block-Room.`
          },
          {
            name: 'DC Capacity',
            param: 'dc_capacity',
            type: 'number',
            description: `Its a mandatory data. It should be sum of all the inverters capacities present in that specific room`
          },
          {
            name: 'Reading frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Filter Config',
            param: 'filter_config',
            type: 'json',
            description: `threshold value needs to be added for junk value *\({"validationRules": {"ac_power": {"maxValue": 20, "minValue": 0}, "active_total_export_cumulative": {"cumulative": {"threshold": 5}}}})`
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-v1,rm-v12)`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-roomname-devicename`
          },
          {
            name: 'Make',
            param: 'make',
            type: 'text',
          },
          {
            name: 'Model',
            param: 'model',
            type: 'text',
          }
    ]
  }
